var map = {
	"./slide1.jpg": 16166,
	"./slide2.jpg": 58632,
	"./slide3.jpg": 39849,
	"./slide4.jpg": 9303,
	"./slide5.jpg": 86291,
	"./slide6.jpg": 76502,
	"./slide7.jpg": 19457,
	"./slide8.jpg": 3841,
	"./slide9.jpg": 87377
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 61761;
module.exports = webpackAsyncContext;